const hasVisibleTabContent = (content) => {
	const directWidgets = Array.from(content.children).some((child) => child.classList.contains('widget'));
	if (directWidgets) {
		return true;
	}

	return Array.from(content.children)
		.filter((child) => child.classList.contains('widget-grid--question-answer') || child.classList.contains('widget-grid--scale'))
		.some((child) => !child.classList.contains('is-hidden') && child.querySelector('.widget'));
};

const updateScrollableState = (container) => {
	const tabsList = container.querySelector('.tabs > ul');
	const tabs = container.querySelector('.tabs');

	if (!tabsList || !tabs) {
		return;
	}

	const isScrollable = tabsList.scrollWidth > tabsList.clientWidth + 1;
	const isAtEnd = tabsList.scrollLeft + tabsList.clientWidth >= tabsList.scrollWidth - 1;

	tabs.classList.toggle('tabs--is-scrollable', isScrollable);
	tabs.classList.toggle('tabs--at-end', !isScrollable || isAtEnd);
};

const activateTab = (tabs, tabContents, activeIndex) => {
	tabs.forEach((tab, index) => {
		const isActive = index === activeIndex && !tab.classList.contains('is-hidden');
		tab.classList.toggle('is-active', isActive);
	});

	tabContents.forEach((content, index) => {
		const isActive = index === activeIndex && !content.classList.contains('is-hidden');
		content.classList.toggle('is-active', isActive);
	});
};

const initializeTabs = (container) => {
	const tabs = Array.from(container.querySelectorAll('.tab'));
	const tabContents = Array.from(container.querySelectorAll('.tab-content'));
	const currentActiveIndex = tabs.findIndex((tab) => tab.classList.contains('is-active'));
	const tabsList = container.querySelector('.tabs > ul');

	if (tabsList && tabsList.dataset.tabsScrollBound !== 'true') {
		tabsList.addEventListener('scroll', () => {
			updateScrollableState(container);
		}, { passive: true });

		tabsList.dataset.tabsScrollBound = 'true';
	}

	tabs.forEach((tab, index) => {
		if (tab.dataset.tabsBound === 'true') {
			return;
		}

		tab.addEventListener('click', () => {
			if (tab.classList.contains('is-hidden')) {
				return;
			}

			activateTab(tabs, tabContents, index);
		});

		tab.dataset.tabsBound = 'true';
	});

	const visibleIndices = [];

	tabContents.forEach((content, index) => {
		const hasContent = hasVisibleTabContent(content);
		content.classList.toggle('is-hidden', !hasContent);
		content.classList.remove('is-active');

		if (tabs[index]) {
			tabs[index].classList.toggle('is-hidden', !hasContent);
			tabs[index].classList.remove('is-active');
		}

		if (hasContent) {
			visibleIndices.push(index);
		}
	});

	container.classList.toggle('is-hidden', visibleIndices.length === 0);

	if (!visibleIndices.length) {
		return;
	}

	const nextActiveIndex = visibleIndices.includes(currentActiveIndex) ? currentActiveIndex : visibleIndices[0];

	activateTab(tabs, tabContents, nextActiveIndex);
	updateScrollableState(container);
};

const initializeAllTabs = () => {
	const tabsContainers = document.querySelectorAll('.widget-tabs');
	tabsContainers.forEach(initializeTabs);
};

document.addEventListener('DOMContentLoaded', initializeAllTabs);
window.addEventListener('questionnaire:results', initializeAllTabs);
window.addEventListener('resize', initializeAllTabs);
